import AuthLayout from "../Layouts/AuthLayout";
import ChangePassword from "../Screens/AuthScreen/ChangePassword";
import Forgotcredentials from "../Screens/AuthScreen/ForgotPassword/ForgotCredentials";
import Forgotpassword from "../Screens/AuthScreen/ForgotPassword/Forgotpassword";
import Login from "../Screens/AuthScreen/Login";
import OtpVerification from "../Screens/AuthScreen/OtpVerification";
import Register from "../Screens/AuthScreen/Register";

export const authRouter = {
  element: <AuthLayout />,
  children: [
    { path: "/", index: true, element: <Login /> },
    {
      path: "register",
      element: <Register />,
    },
    {
      path: "/otpverification",
      element: <OtpVerification />,
    },
    // {
    //   path: "/forgtcredentials",
    //   element: <Forgotcredentials />,
    // },
    {
      path: "/forgotpassword",
      element: <Forgotpassword />,
    },
    // {
    //   path: "/forgotorganizationcode",
    //   element: <Forgotpassword />,
    // },
    {
      path: "/changepassword",
      element: <ChangePassword />,
    },
  ],
};
